import { now, toApiDateTime } from "@src/utils/dates";
import { gt, maxValue, required } from "@src/utils/forms/validators";
import type { NumberModel } from "@src/utils/models";
import { FieldState, FormState } from "formstate";

export class Form {
  from_credit_account_id = new FieldState("").validators(required);
  amount: FieldState<NumberModel>;
  performed_at: FieldState<Date>;

  maxAmount?: NumberModel;

  _form: FormState<FieldState<any>[]>;

  constructor(amount: NumberModel) {
    this.maxAmountValidate = this.maxAmountValidate.bind(this);
    this.amount = new FieldState(amount).validators(
      gt(0),
      this.maxAmountValidate,
    );
    this.performed_at = new FieldState(now());
    this._form = new FormState([
      this.from_credit_account_id,
      this.amount,
      this.performed_at,
    ]);
  }

  private maxAmountValidate($: NumberModel) {
    if (this.maxAmount === undefined) {
      return null;
    }

    return maxValue(this.maxAmount.value)($.value);
  }

  reset() {
    this._form.reset();
  }

  async validate() {
    return this._form.validate();
  }

  serialize() {
    return {
      from_credit_account_id: this.from_credit_account_id.value,
      amount: this.amount.value.denominatedValue,
      performed_at: toApiDateTime(this.performed_at.value),
    };
  }
}
